import React from 'react';
import { XIcon } from 'lucide-react';
import { Section } from './Shared';
import { painPoints } from '../data/pack';
export const PainPoints = () => {
  return <Section className="max-w-4xl" data-id="element-168" data-mp="2lp556r9nb2to">
      <div className="mb-12 text-center" data-id="element-169" data-mp="26yxtcue58i1y">
        <h2 className="mb-6 font-serif text-3xl font-semibold leading-tight text-brand-burgundy md:text-4xl lg:text-5xl" data-id="element-170" data-mp="26y60hrbxkyfd">
          How Much Time Do You Lose Planning Every Session From Scratch?
        </h2>
        <p className="mx-auto mb-4 max-w-2xl text-sm text-brand-text md:text-base" data-id="element-171" data-mp="1xzuczy6d2gr5">
          You already have knowledge, training and experience. But when your
          material is scattered across notebooks, videos and disconnected notes,
          preparing a professional session becomes unnecessarily difficult.
        </p>
        <p className="mx-auto max-w-2xl text-base font-semibold text-brand-goldDark md:text-lg" data-id="element-172" data-mp="3idunujt3jzgp">
          Having knowledge is not the same as having a clear system for applying
          it.
        </p>
      </div>

      <div className="paper-panel mb-12 rounded-3xl p-6 md:p-10" data-id="element-173" data-mp="1z05bvdw6lb3u">
        <h3 className="mb-6 flex items-center font-serif text-lg font-semibold text-brand-burgundy md:text-xl" data-id="element-174" data-mp="1yyc1pomd08r3">
          <XIcon className="mr-2 h-6 w-6 shrink-0 text-brand-burgundy" data-id="element-175" data-mp="27sqqchss4vmv" />
          Without a structured system:
        </h3>
        <ul className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-x-8" data-id="element-176" data-mp="23r562bdx1f2n">
          {painPoints.map(point => <li key={point} className="flex items-start" data-id="element-177" data-mp="1g2lwlsj4qw8z">
              <XIcon className="mr-3 mt-0.5 h-5 w-5 shrink-0 text-brand-burgundy/80" data-id="element-178" data-mp="1b2zilgvh9bz4" />
              <span className="text-sm text-brand-text md:text-base" data-id="element-179" data-mp="1p2hd8cvgfjge">
                {point}
              </span>
            </li>)}
        </ul>
      </div>

      <div className="text-center" data-id="element-180" data-mp="1k1uth69gva8r">
        <h3 className="mx-auto max-w-2xl font-serif text-2xl font-medium italic text-brand-burgundy md:text-3xl" data-id="element-181" data-mp="30hnulh05orwm">
          Your practice does not need more disconnected information. It needs
          organization, visual clarity and ready-to-use tools.
        </h3>
      </div>
    </Section>;
};